module.exports = __webpack_public_path__ + "images/emails/digest/clipboard-t-dd51c461.png";